import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import { BreadcrumbSchema } from '../components/JsonLdSchema';
import { posts } from '../blog/index';

function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString('en-IN', {
    year: 'numeric', month: 'long', day: 'numeric',
  });
}

export default function BlogList() {
  return (
    <main style={{ paddingTop: 64 }}>
      <SEOHead
        title="Restaurant POS & F&B Technology Blog | DPOS"
        description="Guides on restaurant POS software, F&B management, billing, and restaurant technology in India — practical tips to grow your restaurant business."
        keywords="restaurant POS software blog India, best restaurant software tips, F&B technology India, restaurant billing software guide, POS software comparison India, restaurant management tips, how to choose POS software India, restaurant technology blog, food business software India"
        canonical="/blog"
      />
      <BreadcrumbSchema items={[
        { name: 'Home', path: '/' },
        { name: 'Blog' },
      ]} />

      {/* Header */}
      <section style={{ padding: '72px 24px 48px', background: '#fff' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <p style={{
            fontSize: 13, fontWeight: 600, color: '#CC0000',
            textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: 12,
          }}>
            Resource Hub
          </p>
          <h1 style={{
            fontSize: 'clamp(32px, 4vw, 52px)',
            fontWeight: 800, color: '#111827', marginBottom: 16, lineHeight: 1.15,
          }}>
            The DPOS Blog: Restaurant POS & F&amp;B Guides
          </h1>
          <p style={{ fontSize: 17, color: '#6b7280', maxWidth: 560, lineHeight: 1.7 }}>
            Insights on the best POS software, F&amp;B management, restaurant technology,
            and practical tips to run a more profitable food business.
          </p>
        </div>
      </section>

      {/* Post grid */}
      <section style={{ padding: '0 24px 80px', background: '#f9fafb' }}>
        <div style={{
          maxWidth: 1100, margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
          gap: 28, paddingTop: 32,
        }}>
          {posts.map(post => (
            <article
              key={post.slug}
              style={{
                background: '#fff',
                border: '1px solid #e5e7eb',
                borderRadius: 16,
                overflow: 'hidden',
                transition: 'box-shadow 0.2s',
              }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.08)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
            >
              {/* Card top accent */}
              <div style={{ height: 4, background: '#CC0000' }} />

              <div style={{ padding: '28px 24px 32px' }}>
                <div style={{
                  display: 'flex', gap: 12, marginBottom: 16,
                  flexWrap: 'wrap', alignItems: 'center',
                }}>
                  <span style={{
                    fontSize: 11, fontWeight: 700, color: '#6b7280',
                    textTransform: 'uppercase', letterSpacing: '0.08em',
                  }}>
                    {formatDate(post.date)}
                  </span>
                  <span style={{
                    fontSize: 11, fontWeight: 600,
                    background: '#fef2f2', color: '#CC0000',
                    padding: '2px 10px', borderRadius: 100,
                  }}>
                    {post.readTime}
                  </span>
                </div>

                <h2 style={{
                  fontSize: 18, fontWeight: 700, color: '#111827',
                  lineHeight: 1.4, marginBottom: 12,
                }}>
                  {post.title}
                </h2>

                <p style={{
                  fontSize: 14, color: '#6b7280', lineHeight: 1.7, marginBottom: 24,
                }}>
                  {post.description}
                </p>

                <Link
                  to={`/blog/${post.slug}`}
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: 6,
                    color: '#CC0000', fontWeight: 600, fontSize: 14,
                    transition: 'gap 0.2s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.gap = '10px'}
                  onMouseLeave={e => e.currentTarget.style.gap = '6px'}
                >
                  Read Article →
                </Link>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section style={{
        padding: '64px 24px', background: '#111827', textAlign: 'center',
      }}>
        <div style={{ maxWidth: 600, margin: '0 auto' }}>
          <h2 style={{ fontSize: 28, fontWeight: 800, color: '#fff', marginBottom: 16 }}>
            Ready to see DPOS in action?
          </h2>
          <p style={{ fontSize: 15, color: '#9ca3af', marginBottom: 32, lineHeight: 1.7 }}>
            Book a free demo and discover why 100+ restaurants trust DPOS as their best F&amp;B and POS software.
          </p>
          <Link to="/contact" style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            background: '#CC0000', color: '#fff',
            padding: '14px 32px', borderRadius: 10, fontSize: 15, fontWeight: 700,
          }}>
            Contact for Free Demo →
          </Link>
        </div>
      </section>
    </main>
  );
}
